<div #trackingContaner class="m-click-tracking" (click)="clickedArea($event)">
  <img #imageContainer [src]="this.imgSrc" />
  <div class="m-click-tracking__click-render">
    <span
      *ngFor="let item of trackClicks"
      [ngStyle]="{
        left: item.x * 100 + '%',
        top: item.y * 100 + '%',
        backgroundColor: item.color ? item.color : dotColor
      }"
      class="dot"
    ></span>
  </div>
</div>
